import * as React from 'react';
import type {
  CreateTransportRoutePayload as Payload,
} from 'contracts/transport-routes';
import { apiGeneral, handleApiError } from 'services/api';

export const useCreateTransportRoute = () => {
  const createTransportRoute = React.useCallback(async (payload: Payload) => {
    try {
      await apiGeneral.post('/general-route', payload);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    createTransportRoute,
  };
};